import React from "react";
import Context from "../../../../context";
import { CustomView, CustomModal, CustomButton2 } from "../../../../components";

import "./index.sass";
import { useTranslation } from "react-i18next";

const Reject = () => {
  const {
    showModal,
    setShowModal,
    isLoading,
    selectedService,
    approveFunction,
  } = React.useContext(Context.ServiceScreen);

  const { t } = useTranslation();

  // ?? ===========================================================================================================
  // ??                                              JSX Content
  // ?? -----------------------------------------------------------------------------------------------------------

  return (
    <section id="school-reject-modal-container">
      <CustomModal
        onClose={() => setShowModal!("NONE")}
        open={showModal === "REJECT"}
      >
        <CustomView.Container className="reject-form-content">
          <CustomView.Row className="form-row">
            <CustomView.Column
              large={3}
              medium={4}
              small={6}
              className="form-colum"
            >
              <CustomButton2
                isLoading={isLoading}
                onClick={() => setShowModal!("NONE")}
                title="لغو"
              />
            </CustomView.Column>
            <CustomView.Column
              large={3}
              medium={4}
              small={6}
              className="form-colum"
            >
              <CustomButton2
                type="danger"
                title={t("disapprove")}
                onClick={() =>
                  approveFunction!({
                    _id: selectedService?._id,
                    isApprove: false,
                  })
                }
                isLoading={isLoading}
              />
            </CustomView.Column>
          </CustomView.Row>
        </CustomView.Container>
      </CustomModal>
    </section>
  );
};

export default Reject;
